import { Box, Typography } from "@material-ui/core";
import { Fragment, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { formatAction, formatCondition, volumeBasedConditions } from "../../../../utils/base-agreement-formatters";
import startUpper from "../../../../utils/start-upper";
import { TrFun } from "../../../../utils/types";
import { resolveContent } from "../../../agreements/agreement/details-cards/Scenarios";
import { GetCaseByIdQuery } from "../../types/queries.generated";
import useStyles from "../../use-styles";

type ScenarioItem = {
	bullet: string;
	content: string;
};

function formatSllScenario(
	scenario: NonNullable<GetCaseByIdQuery["cases"][number]["baseAgreement"]>["scenarios"][number],
	agreement: NonNullable<GetCaseByIdQuery["cases"][number]["baseAgreement"]>,
	t: TrFun
): ScenarioItem[] {
	return [
		...scenario.conditions.map((c) => ({
			bullet: `${t(c.order === 0 ? "if" : scenario.operator)}`.toUpperCase(),
			content: resolveContent(formatCondition(c, t, agreement.dataContainers, agreement.currency)),
		})),
		...scenario.actions.map((a) => ({
			bullet: `${t("then")}`.toUpperCase(),
			content: formatAction(
				a as any,
				agreement,
				scenario.conditions.find((condition) => volumeBasedConditions.includes(condition.conditionType)) as any,
				t,
				agreement.dataContainers
			),
		})),
	];
}

export function Scenarios(props: { agreement: NonNullable<GetCaseByIdQuery["cases"][number]["baseAgreement"]> }) {
	const { t } = useTranslation();
	const { fw500, mr1 } = useStyles();
	const scenarios = useMemo(() => props.agreement.scenarios.map((s) => formatSllScenario(s, props.agreement, t)), [props.agreement, t]);

	return (
		<Fragment>
			{scenarios?.map((scenario, index) => (
				<Box key={index} pl={4} pt={1} pb={8} width="100%">
					<Typography align="left" className={`${fw500} ${mr1}`} variant="body2" color="textSecondary">{`${
						index + 1
					}. ${startUpper(t("scenario"))}`}</Typography>
					{scenario.map((scenarioParts, idx) => (
						<Box display="flex" width="100%" key={idx} mt={1}>
							<Box paddingRight={2} width="10%">
								<Typography>{scenarioParts.bullet}</Typography>
							</Box>
							<Box paddingRight={2} width="90%">
								<Typography>{scenarioParts.content}</Typography>
							</Box>
						</Box>
					))}
				</Box>
			))}
		</Fragment>
	);
}
